import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { accountRoute } from '../../routes';

import connect from '../../utils/connect';
import baseUrl from '../../utils/baseUrl';

import Splitter from './block/splitter';
import ContentBlock from './block/content';
import ConfirmDialog from  '../form/confirm';
import Spinner from '../svg/spinner';

//import translate from '../../utils/translate';

import { CaseList } from '../relatedcases/relatedcases';
import Dropdown from '../dropdown/dropdown';

import css from './caseList.scss';

//import * as actions from '../../actions/account';
import axios from 'axios';
import { dispatchError } from '../../actions/errors';

import { fetchCases, clearCollection } from '../../actions/account';

import { redirectToAccountIfNoProfile } from '../../utils/authorization';

class AccountCaseList extends Component {

	constructor(props) {
		super();

		this.mounted = true;
		this.state = {
			waiting: true,
			items: [],
			showMore: false,
		};
	}

	componentWillMount() {
		axios({
			url: baseUrl + '/api/account/profiles/cases',
			method: 'get',
			responseType: 'json',
		})
		.then((res) => {
			let newState = {
				...this.state,
				waiting: false,
			};
			if (res.data && res.data.cases) {
				newState.items = res.data.cases;
			} else {
				this.props.dispatch(dispatchError('Invalid data received.'));
			}

			if (this.mounted) {
				this.setState(newState);
			}
		})
		.catch((res) => {
			if (res.data && res.data.message) {
				this.props.dispatch(dispatchError(res.data));
			}

			if (this.mounted) {
				this.setState({
					...this.state,
					waiting: false,
				});
			}
		});
	}

	componentWillReceiveProps(nextProps) {}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let listClass = 'account-cases__list-container';
		let loadmoreClass = 'related-cases__load-more span8 span100p-mobile pixel-pattern';
		if (this.state.showMore) {
			listClass += ' account-cases__list-container--active';
			loadmoreClass += ' active';
		}

		return (
			<div className='account-cases'>
				<Helmet title='The FWA - Account - Projects' />

				<ContentBlock title={'Your projects'} sticky={true} browser={this.props.browser}>
					<div className='account-block-content__content__buttons'>
						<Link to={accountRoute(`/profile/projects/create`)} className='button button--dark '>Submit your project</Link>
					</div>
				</ContentBlock>

				{(this.state.waiting) && this.renderWaiting()}

				<div className={listClass}>
					{<CaseList browser={this.props.browser} cases={this.state.items} contentComp={AccountCaseListEditButton}></CaseList>}

					<div className='account-cases__fill span2'></div>

					<div className='cf'></div>

					{(this.state.items.length > 6) && (
						<a href='javascript:void(0);' onClick={this.toggleMore.bind(this)} className={loadmoreClass}>
							<span className='span2 related-cases__load-more__arrow-holder'>
								<span className='related-cases__load-more__arrow'></span>
							</span>

							{(this.state.showMore) ? (
								<span>Show less ({this.state.items.length})</span>
							) : (
								<span>Show more ({this.state.items.length})</span>
							)}
						</a>
					)}
				</div>

				<div className='cf'></div>

			</div>
		);
	}

	setWaiting(state) {
		this.setState({ ...this.state, waiting: state });
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	toggleMore() {
		this.setState({
			...this.state,
			showMore: !this.state.showMore,
		});
	}
}

export default connect(AccountCaseList);

export class AccountCaseListEditButton extends Component {
	static propTypes = {
		caseItem: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
	};

	constructor(props) {
		super();
	}

	render() {
		return (
			<div key='menu' className='account-cases__content'>
				<a className='account-cases__content__button button button--action' ref='menu'>...</a>

				<Dropdown key='dropdown' attachTo={() => this.refs.menu} pointTo='AUTO' browser={this.props.browser}>
					<ol key='dropdown-ol'>
						<li key='link-edit'><Link to={accountRoute(`/profile/projects/${this.props.caseItem.id}`)}>Edit</Link></li>
					</ol>
				</Dropdown>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/caseList.js
 **/